import { get, isEmpty } from 'lodash';

import initializeForm from './initializeForm';
import openModal from './openModal';
import setIsNewRecord from './setIsNewRecord';

export default (values) => (dispatch) => {
    const newValues = {
        company_name: values.company_name,
        company_position: values.company_position,
        emails: isEmpty(values.emails)
            ? [
                  {
                      email: '',
                      email_type: '',
                  },
              ]
            : values.emails,
        id: values.id,
        name: values.name,
        rfc: values.rfc,
        status_flag: values.status_flag,
        telephones: isEmpty(values.telephones)
            ? [
                  {
                      telephone: '',
                      phone_type: '',
                  },
              ]
            : values.telephones,
        user: get(values.user, 'id', ''),
    };

    dispatch(initializeForm(newValues));
    dispatch(setIsNewRecord(false));
    dispatch(openModal(true));
};
